export interface SummaryCardShippingAmounts {
  /** Label, carrier upgrade, pickup and exchange shipping charged by card at submit. */
  shippingDueNow: number;
  showsCarrierUpgrade: boolean;
}

/**
 * Shipping the shopper pays by card at submit. The carrier upgrade is part of
 * the shopper-owed shipping fee, so it is deducted or charged with the label.
 */
export function getSummaryCardShippingAmounts({
  labelDeducted,
  stripeShippingFee,
  carrierUpgradeFeeComponent,
}: {
  labelDeducted: boolean;
  stripeShippingFee: number;
  carrierUpgradeFeeComponent: number | undefined;
}): SummaryCardShippingAmounts {
  return {
    shippingDueNow:
      !labelDeducted && stripeShippingFee > 0 ? stripeShippingFee : 0,
    showsCarrierUpgrade: (carrierUpgradeFeeComponent ?? 0) > 0,
  };
}
